import { Component } from '@angular/core';
import { HeaderComponent } from '../../../header/header.component';
import { MenuComponent } from '../../../menu/menu.component';

@Component({
  selector: 'app-nav-layout',
  imports: [HeaderComponent, MenuComponent],
  templateUrl: './nav-layout.component.html',
})
export class NavLayoutComponent {}
